import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'

import { strings } from '@constants'
import { updateOrganisationApi } from '@data/conn/put/organisation'
import { showLoader, showToast } from '@data/state/action'
import { toggleDrawer } from '@data/state/action/root'
import { DrawerBodyWrapper, DrawerFooterWrapper, TOAST_TYPE } from '@base'
import { Button, Input } from '@baseV2'

import { InputsWrapper } from '../styles'

const EditOrgName = ({ orgDetails, update }) => {
	const dispatch = useDispatch()
	const [orgName, setOrgName] = useState(orgDetails?.organisation_name ?? '')

	useEffect(() => {
		setOrgName(orgDetails?.organisation_name ?? '')
	}, [orgDetails?.organisation_name])

	const onNameUpdate = () => {
		if (!orgName.trim()) return
		dispatch(showLoader(true))
		updateOrganisationApi(orgDetails.organisation_id, 'ORG_NAME', orgName.trim())
			.then(() => {
				dispatch(showToast(true, strings('organisation_update_success'), { type: TOAST_TYPE.SUCCESS }))
				dispatch(toggleDrawer(false))
				update()
			})
			.catch((err) => {
				console.log(err)
				dispatch(showToast(true, strings('organisation_update_failure'), { type: TOAST_TYPE.ERROR }))
			})
			.finally(() => dispatch(showLoader(false)))
	}

	return (
		<>
			<DrawerBodyWrapper>
				<InputsWrapper>
					<Input
						id='org-name-v2'
						label='Organisation Name'
						placeholder='Enter a name'
						value={orgName}
						onChange={(e) => setOrgName(e.target.value.trimStart())}
					/>
				</InputsWrapper>
			</DrawerBodyWrapper>
			<DrawerFooterWrapper>
				<Button color='primary' disabled={!orgName} onClick={onNameUpdate}>
					{strings('update')}
				</Button>
			</DrawerFooterWrapper>
		</>
	)
}

export default EditOrgName
